import { motion } from "framer-motion";

const AIScanEffect = () => {
  return (
    <div className="absolute inset-0 z-50 transform-gpu will-change-contents flex items-center justify-center">
      <div className="relative w-full h-full overflow-hidden rounded-2xl pointer-events-none">
        {/* 🌊 Vertical Scan Beam */}
        <motion.div
          className="absolute top-0 left-0 w-full h-full"
          animate={{ y: ["100%", "-100%"] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        >
          <div className="relative w-full h-full">
            <div className="absolute inset-x-0 top-1/2 h-32 -translate-y-1/2 bg-gradient-to-b from-transparent via-violet-400 to-transparent opacity-70" />
          </div>
        </motion.div>

        {/* ⬆️ Code Pulse Bars (fewer + optimized) */}
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={`pulse-${i}`}
            className="absolute bottom-0 w-[2px] rounded-full bg-violet-400/60"
            style={{ left: `${12 + i * 14}%` }}
            animate={{
              height: ["10%", "60%", "10%"],
              opacity: [0.1, 0.4, 0.1],
            }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.2,
            }}
          />
        ))}

        {/* 🧵 Grid Overlay (no animation, just a texture) */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(167,139,250,0.08)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(167,139,250,0.08)_1px,_transparent_1px)] bg-[size:24px_24px] pointer-events-none" />
      </div>
    </div>
  );
};

export default AIScanEffect;
